import { h } from 'preact';
import PropTypes from 'prop-types';
import CSSTransition from 'react-transition-group/CSSTransition';

// Utils
import {
  calcColumns,
  stepHasRequiredData,
  getStepWaitText,
  isLoadingOnField,
  stepShowHide,
} from '../../../utilities/form/formUtils';

// Constants
import { stepComponents } from '../../../constants/Steps';

// Components
import FormActions from '../../Form/FormActions';
import StepHeader from '../General/StepHeader';

const ProductPrice = ({
  componentProps,
  title,
  desc,
  submitText,
  submitButton,
  dispatch,
  errors,
  handleSubmit,
  onBlur,
  onChange,
  setValues,
  touched,
  values,
  tracking,
  setFormValues,
  formActions,
  requiredData,
  userData,
  actionProps,
  actionVariant,
  initialValues,
  setFieldValue,
}) => {
  const formParams = {
    handleSubmit,
    onChange,
    onBlur,
    errors,
    touched,
    setValues,
    values,
    setFormValues,
    dispatch,
    userData,
    setFieldValue,
  };

  return (
    <article className="step step--price">

      {(title || desc) && (
        <StepHeader title={title} desc={desc}/>
      )}

      {/* If there's any props */}
      {componentProps.length > 0 && (
        <div className="step__content product__price">
          {componentProps.map(componentProp => {
            const { loadingOnField } = componentProp;
            const hidden = componentProp.hidden ? componentProp.hidden : false;
            const showHide = componentProp.showHide ? componentProp.showHide : null;
            const inputParams = {
              ...componentProp,
              ...formParams,
              isLoading: loadingOnField ? isLoadingOnField(loadingOnField, userData) : null,
              'columns': calcColumns(componentProp),
              'children': componentProps,
              hidden: (stepShowHide(hidden, showHide, userData, values)),
              initialValues: { ...initialValues },
            };

            const InputComponent = stepComponents[componentProp.type];
            return (
              <CSSTransition
                in={inputParams.hidden !== true}
                timeout={300}
                classNames="slideInTop"
                unmountOnExit
              >
                <InputComponent {...inputParams}/>
              </CSSTransition>
            );
          })}

          {/* Actions Button */}
          {submitButton &&
          <FormActions
            formActions={formActions}
            submitText={submitText}
            submitButton={submitButton}
            isValid={stepHasRequiredData(requiredData, userData, values)}
            dispatch={dispatch}
            values={values}
            waitText={getStepWaitText(requiredData, userData, values)}
            tracking={tracking}
            formParams={formParams}
            actionProps={actionProps}
            userData={userData}
            actionVariant={actionVariant}
            setFieldValue={setFieldValue}
          />
          }

        </div>
      )}

    </article>
  );
};

export default ProductPrice;

ProductPrice.defaultProps = {
  actionProps: null,
  desc: null,
  errors: null,
  formActions: null,
  handleSubmit: null,
  onBlur: null,
  onChange: null,
  requiredData: {},
  setFormValues: null,
  setValues: null,
  submitButton: true,
  title: null,
  touched: null,
  tracking: ['tealiumSubmit'],
  userData: null,
  values: null,
  actionVariant: 'greyBox',
};

ProductPrice.propTypes = {
  componentProps: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired,
  submitText: PropTypes.string.isRequired,
  actionProps: PropTypes.array,
  desc: PropTypes.string,
  actionVariant: PropTypes.string,
  errors: PropTypes.object,
  formActions: PropTypes.array,
  tracking: PropTypes.array,
  handleSubmit: PropTypes.func,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  requiredData: PropTypes.object,
  setFormValues: PropTypes.func,
  setValues: PropTypes.func,
  submitButton: PropTypes.bool,
  title: PropTypes.string,
  touched: PropTypes.object,
  userData: PropTypes.object,
  values: PropTypes.object,
  initialValues: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Steps/ProductPrice/index.jsx